import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import * as Styled from "./AppLogo.styled";
export const AppLogo = forwardRef((props, ref) => {
    const { children, shouldHideOnMobile = true, ...otherProps } = props;
    return (_jsx(Styled.AppLogo, { "data-testid": "AppLogo", ref: ref, shouldHideOnMobile: shouldHideOnMobile, ...otherProps, children: children && children }));
});
AppLogo.displayName = "AppLogo";
